import { getLocale } from '@umijs/max';

/**
 * 与后端 display_text 一致的语言 key：zh_CN / en_US / km_KH
 */
export type DisplayTextLocaleKey = 'zh_CN' | 'en_US' | 'km_KH';

const VALID_KEYS: DisplayTextLocaleKey[] = ['zh_CN', 'en_US', 'km_KH'];

/**
 * 根据当前 Umi 语言（getLocale）返回 display_text 使用的 key
 */
export function getDisplayTextLocaleKey(): DisplayTextLocaleKey {
  try {
    const locale = getLocale?.();
    if (locale && VALID_KEYS.includes(locale as DisplayTextLocaleKey)) {
      return locale as DisplayTextLocaleKey;
    }
  } catch {
    // 非 Umi 环境或未挂载
  }
  return 'zh_CN';
}

/**
 * 从 display_text 对象中按当前语言优先取展示文案，无则回退 zh_CN -> en_US -> km_KH -> fallback
 */
export function getDisplayTextByLocale(
  displayText: Record<string, string> | null | undefined,
  fallback = '-',
): string {
  if (!displayText || typeof displayText !== 'object') return fallback;
  const key = getDisplayTextLocaleKey();
  if (displayText[key]) return String(displayText[key]);
  if (displayText.zh_CN) return String(displayText.zh_CN);
  if (displayText.en_US) return String(displayText.en_US);
  if (displayText.km_KH) return String(displayText.km_KH);
  return fallback;
}
